import { useMeasureDiscreteEvent } from '../metrics/useMeasureDiscreteEvent';
export const useTrackVmSessionStatus = (courseId, environment, message) => {
  const {
    increment: incrementSessionDisconnect
  } = useMeasureDiscreteEvent('campus__vm_session_disconnect', {
    courseId,
    environment,
    message
  });
  const {
    increment: incrementSessionDeath
  } = useMeasureDiscreteEvent('campus__vm_session_death', {
    courseId,
    environment,
    message
  });
  const {
    increment: incrementSessionStart
  } = useMeasureDiscreteEvent('campus__vm_session_start', {
    courseId,
    environment
  });
  return {
    incrementSessionDeath,
    incrementSessionDisconnect,
    incrementSessionStart
  };
};